import React from 'react';

interface ViewModeControlsProps {
  viewMode: 'liste' | 'card';
  onViewModeChange: (mode: 'liste' | 'card') => void;
}

const ViewModeControls: React.FC<ViewModeControlsProps> = ({ viewMode, onViewModeChange }) => {
  const viewModes = [
    { key: 'liste', label: 'Liste', icon: '📋' },
    { key: 'card', label: 'Cartes', icon: '🔲' }
  ] as const;

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-gray-700 font-medium">Affichage:</span>
      <div className="flex border border-gray-300 rounded-md overflow-hidden">
        {viewModes.map((mode) => (
          <button
            key={mode.key}
            onClick={() => onViewModeChange(mode.key)}
            className={`px-3 py-2 text-sm font-medium transition-colors ${
              viewMode === mode.key
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
            title={mode.label}
          >
            <span className="mr-1">{mode.icon}</span>
            {mode.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ViewModeControls;
